import type { SendEventParams } from '@/utils/sendEvent';
import { PixelResponse } from '../../types';
import { BaseTracker } from './BaseTracker';

export interface IViewContentData {
  content_id?: string;
  content_name?: string;
  content_type?: string;
  content_category?: string;
  value?: number;
  [key: string]: unknown;
}

/**
 * Tracker para eventos VIEW_CONTENT (visualização de conteúdo)
 */
export class ViewContentTracker extends BaseTracker {
  public getPayload(data: IViewContentData = {}): SendEventParams {
    return {
      category: 'ENGAGEMENT',
      type: 'VIEW_CONTENT',
      visitorId: this.visitorId,
      eventData: {
        content_id: data.content_id,
        content_name: data.content_name,
        content_type: data.content_type,
        content_category: data.content_category,
        value: data.value,
        page_url:
          typeof window !== 'undefined' ? window.location.href : undefined,
        page_title:
          typeof document !== 'undefined' ? document.title : undefined,
        ...data,
      },
      config: this.config,
      sessionId: this.sessionId,
      version: this.version,
    };
  }

  /**
   * Rastreia visualização de conteúdo
   */
  public async track(data: IViewContentData = {}): Promise<PixelResponse> {
    return this.sendEvent(this.getPayload(data));
  }
}
